export const WEBIM_LOCATION = 'DealSaleCcPromo';
export const WEBIM_INFORMER_VISIBLE = 'dealSaleWIV';
